"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _react = _interopRequireDefault(require("react"));
var _dsIcons = require("@olxbr/ds-icons");
var _style = require("./style");
var _messageUtil = require("../../../../../helpers/messageUtil");
var _jsxRuntime = require("react/jsx-runtime");
function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    "default": obj
  };
}
var MessagePreview = function MessagePreview(_ref) {
  var seen = _ref.seen,
    adStatus = _ref.adStatus,
    lastMessage = _ref.lastMessage;
  var isImage = (0, _messageUtil.isOLXImageURL)(lastMessage);
  return /*#__PURE__*/(0, _jsxRuntime.jsxs)(_style.Wrapper, {
    children: [/*#__PURE__*/(0, _jsxRuntime.jsx)(_style.TextPreview, {
      seen: seen,
      adStatus: adStatus,
      children: !isImage ? lastMessage : /*#__PURE__*/(0, _jsxRuntime.jsxs)(_style.ImageWrapper, {
        children: [/*#__PURE__*/(0, _jsxRuntime.jsx)(_dsIcons.Camera, {
          size: 18
        }), "Foto"]
      })
    }), !seen && /*#__PURE__*/(0, _jsxRuntime.jsx)(_style.Badge, {})]
  });
};
var _default = exports["default"] = MessagePreview;